// 华润项目业务区接口
import * as HTTP from '@/utils/http'
// 文档服务接口
const type = 'DOCUMENT'
export default {
    /*上传文件*/
    uploadFile(params) {
        "use strict";
        return HTTP.POST('/api/file/upload', params, type)
    },
    /*查询文件目录*/
    getDirTree(params) {
        "use strict";
        return HTTP.POST('/api/file/dirTree', params, type)
    },
    /*查询文件目录*/
    getFileList(params) {
        "use strict";
        return HTTP.POST('/api/file/list', params, type)
    },
    /*获取文件夹的父级路径*/
    queryParentFolderPath(params) {
        "use strict";
        return HTTP.GET('/api/file/queryParentFolderPath', params, type)
    },
    /**
     * 文件移动
     * @params params
     * @returns {*}
     */
    moveFile(params) {
        "use strict";
        return HTTP.POST('/api/file/move', params, type)
    },
    /**
     * 文件复制
     * @params params
     * @returns {*}
     */
    copyFile(params) {
        return HTTP.POST('/api/file/copy', params, type)
    },
    /**
     * 删除文件
     * @params params
     */
    deleteFile(params) {
        return HTTP.POST('/api/file/delete', params, type)
    },
    /**
     * 重命名
     * @params params
     */
    renameApi(params) {
        return HTTP.POST('/api/file/rename', params, type);
    },
    /**
     * 新建文件夹
     */
    createFolder(params) {
        return HTTP.POST('/api/file/createFolder', params, type);
    },
    /**
     * 文件收藏
     * @params params
     */
    fileCollectApi(params) {
        return HTTP.POST('/api/favorite/add', params, type);
    },
    /**
     * 取消文件收藏
     * @params params
     */
    cancelFileCollectApi(params) {
        return HTTP.POST('/api/favorite/cancel', params, type);
    },
    /**
     * 查看历史版本
     * @param params
     * @returns {never}
     */
    viewVersion(params) {
        return HTTP.GET('/api/file/versions', params, type)
    },
    /**
     * 添加浏览记录
     * @param params
     * @returns {never}
     */
    addFileBrowse(params) {
        return HTTP.GET('/api/file/browse/record', params, type)
    },
    /**
     *
     * @param params
     * @returns {*}
     */
    getRecentlyVieweApi(params) {
        return HTTP.POST('/api/file/browse/recent', params, type)
    },
    /**
     * 收藏记录
     * @param params
     */
    myCollectApi(params) {
        return HTTP.POST('/api/favorite/list', params, type)
    },
    /**
     * 批量下载接口
     * @param params
     * @returns {*}
     */
    batchDownloadApi(params){
        return HTTP.POST('/api/file/batchDownload', params, type)
    },
    /**
     * 查询下载历史任务
     * @param params
     */
    queryDownloadTaskList(params){
        return HTTP.POST('/api/file/queryFileDownloadTaskList', params, type)
    },
    /**
     * 分享历史记录列表
     * @param params
     * @returns {*}
     */
    shareHistoryList(params){
        return HTTP.POST('/share/page/list', params)
    },
    /**
     * 通过fileId批量查询文件的转换状态
     * @param params
     * @returns {*}
     */
    queryConvertStatusByFileIds(params){
        return HTTP.POST('/doc/api/file/queryConvertStatusByFileIds', params)
    }
}
